module.exports = __webpack_public_path__ + "static/media/banner_1.d13351cb.jpg";